class ImageCarousel extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.attachEvents()
  }

  attachEvents() {
    const sectionId = this.dataset.sectionId
    const swiper = new Swiper(`.js-image-carousel-${sectionId} .swiper`, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      freeMode: false,
      pagination: {
        el: '.swiper-pagination',
        enabled: true,
        clickable: true
      },
      breakpoints: {
        768: {
          spaceBetween: 20
        }
      }
    });
  }
}

if (!customElements.get('image-carousel')) {
  customElements.define('image-carousel', ImageCarousel)
}
